<template>
  <div>
    <Head title="會員中心 - 系統通知" />
    <notification-template title="會員中心">
      <template #header>系統通知</template>
      <template v-if="$page.props.notifications.length == 0">
        沒有任何系統通知
      </template>
      <template v-else>
        <div class="flex justify-center md:justify-end">
          <Link
            as="Button"
            method="patch"
            :src="route('user.notifications')"
            class="
              cursor-pointer
              p-button-success p-button-rounded p-button-text p-button-sm
            "
            preserve-state
            preserve-scroll
            ><span class="text-fh-blue">全部標記為已讀</span></Link
          >
          <Link
            as="Button"
            method="delete"
            :src="route('user.notifications')"
            class="
              cursor-pointer
              p-button-danger p-button-rounded p-button-text p-button-sm
            "
            preserve-state
            preserve-scroll
            ><span class="text-red">全部清除</span></Link
          >
        </div>
        <div
          class="notification"
          :class="{ unread: !notification.read_at }"
          :key="notification.id"
          v-for="notification in $page.props.notifications"
        >
          <template v-if="notification.data.type == 'orderStatusChanged'">
            <div class="column w-52">
              <div>
                <label>通知時間</label>
                <div class="text-sm">
                  {{ formatDate(notification.created_at) }}
                </div>
              </div>
              <div>
                <label>訂單編號</label>
                <div class="text-sm">
                  {{ notification.data.references.order_no }}
                </div>
              </div>
            </div>
            <div class="column w-128">
              <label>詳細說明</label>
              <div class="summary">
                {{ notification.data.summary }}
              </div>
              <div class="detail">
                {{ notification.data.detail }}
              </div>
            </div>
            <div class="column justify-around">
              <Button
                label="查看訂單"
                @click="showOrder(notification.data.references.order_no)"
              />
            </div>
          </template>
          <template v-if="notification.data.type == 'userLevelChanged'">
            <div class="column w-52">
              <div>
                <label>通知時間</label>
                <div class="text-sm">
                  {{ formatDate(notification.created_at) }}
                </div>
              </div>
            </div>
            <div class="column w-96">
              <label>詳細說明</label>
              <div class="summary">
                {{ notification.data.summary }}
              </div>
              <div class="detail">
                {{ notification.data.detail }}
              </div>
            </div>
            <div class="column justify-around">
              <Button label="會員類型" @click="showUserMembership" />
            </div>
          </template>
          <template v-else>
            <!--  -->
          </template>
          <div class="column flex flex-col justify-around">
            <Link
              as="Button"
              method="patch"
              :data="{ id: notification.id }"
              :src="route('user.notifications')"
              class="
                cursor-pointer
                p-button-success p-button-rounded p-button-text p-button-sm
              "
              :disabled="notification.read_at"
              preserve-state
              preserve-scroll
            >
              <i class="text-fh-blue pi pi-eye"
            /></Link>
            <Link
              as="Button"
              method="delete"
              :data="{ id: notification.id }"
              :src="route('user.notifications')"
              class="
                cursor-pointer
                p-button-danger p-button-rounded p-button-text p-button-sm
              "
              preserve-state
              preserve-scroll
            >
              <i class="text-red pi pi-trash" />
            </Link>
          </div>
        </div>
      </template>
    </notification-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import NotificationTemplate from "./Shared/NotificationTemplate";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    NotificationTemplate,
    Button,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  methods: {
    showOrder(no) {
      this.$inertia.visit(route("user.orders.order", no));
    },
    showUserMembership() {
      this.$inertia.visit(route("user.profile.membership"));
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0") +
        " " +
        date.getHours().toString().padStart(2, "0") +
        ":" +
        date.getMinutes().toString().padStart(2, "0") +
        ":" +
        date.getSeconds().toString().padStart(2, "0")
      );
    },
    statusString(statusCode) {
      return this.$page.props.status_strings[statusCode];
    },
  },
};
</script>

<style lang="postcss">
.notification {
  @apply relative w-full px-2 py-4 mb-2 border border-fh-gray-border flex justify-between flex-wrap;
}

.notification.unread {
  @apply border-fh-pink;
}

.notification .column {
  @apply flex flex-col;
}

.notification .column label {
  @apply text-xs;
}

.notification .column .detail {
  @apply text-sm;
}
</style>